import { DocumentComponent, DocumentComponents } from '../types';

export function collectComponents(
  components: DocumentComponent[],
): DocumentComponents {
  const output: DocumentComponents = {};
  components.forEach((component) => {
    if (component.id == null) { throw new Error('Component ID must be specified'); }
    output[component.id] = component;
  });
  return output;
}
